import { TFunction } from 'i18next';

import { HelpdeskOption } from './types';

export const getSignUpText = (t: TFunction<'authentication-wall'>) => ({
  email: t('signUp.workEmail'),
  firstName: t('common.firstName'),
  genericErrorMessage: t('common.genericErrorTryAgain'),
  helpdesk: t('signUp.helpdesk'),
  lastName: t('common.lastName'),
  orgName: t('common.companyName'),
  submit: t('signUp.submit'),
  successSubtitle: t('signUp.successSubtitle'),
  successTitle: t('signUp.successTitle'),
  title: t('signUp.title'),
});

export const getHelpdeskOptions = (
  t: TFunction<'authentication-wall'>,
): HelpdeskOption[] => [
  {
    label: t('signUp.helpdeskOptions.zendesk'),
    value: 'zendesk',
  },
  {
    label: t('signUp.helpdeskOptions.freshdesk'),
    value: 'freshdesk',
  },
  {
    label: t('signUp.helpdeskOptions.kustomer'),
    value: 'kustomer',
  },
  {
    label: t('signUp.helpdeskOptions.salesforce'),
    value: 'salesforce',
  },
  {
    label: t('signUp.helpdeskOptions.servicenow'),
    value: 'servicenow',
  },
  {
    label: t('signUp.helpdeskOptions.odo'),
    value: 'odo',
  },
  {
    label: t('signUp.helpdeskOptions.jira'),
    value: 'jira',
  },
  {
    label: t('signUp.helpdeskOptions.intercom'),
    value: 'intercom',
  },
  {
    label: t('signUp.helpdeskOptions.gorgias'),
    value: 'gorgias',
  },
  {
    label: t('signUp.helpdeskOptions.other'),
    value: 'other',
  },
];
